/**
 * QuotaMeter — Visual quota indicator for auto-grade usage.
 * LAUNCH:C6.P3
 */
import React from 'react';
import { Check, Zap } from 'lucide-react';

export default function QuotaMeter({ quota }) {
  if (!quota) return null;

  // Paid tier: unlimited
  if (quota.limit === null || quota.limit === undefined) {
    return (
      <div className="px-3 py-2">
        <div className="flex items-center gap-2 text-xs">
          <span className="text-zinc-500">AI Grades</span>
          <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-500/20 text-green-400 rounded-full text-[10px] font-medium">
            <Check className="w-3 h-3" aria-hidden="true" />
            Unlimited
          </span>
        </div>
      </div>
    );
  }

  // Free tier
  const used = quota.used || 0;
  const limit = quota.limit;
  const pct = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;
  const exhausted = used >= limit;

  return (
    <div className="px-3 py-2">
      <div className="flex items-center justify-between text-xs mb-1">
        <span className="text-zinc-500">AI Grades</span>
        <span className={exhausted ? 'text-orange-400 font-medium' : 'text-zinc-400'}>
          {used} of {limit} used
        </span>
      </div>
      <div
        className="h-1.5 bg-zinc-700 rounded-full overflow-hidden"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax={limit}
        aria-valuenow={used}
        aria-label={`${used} of ${limit} AI grades used`}
      >
        <div
          className={`h-full rounded-full transition-all ${exhausted ? 'bg-orange-500' : 'bg-green-500'}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {exhausted ? (
        <button className="mt-1.5 flex items-center gap-1 text-[10px] text-orange-400 hover:text-orange-300 transition-colors">
          <Zap className="w-3 h-3" aria-hidden="true" />
          Upgrade to unlock
        </button>
      ) : (
        <button className="mt-1.5 text-[10px] text-zinc-500 hover:text-zinc-400 transition-colors">
          Upgrade for unlimited
        </button>
      )}
    </div>
  );
}
